// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--a3b6f";
export var footerBottom = "footer-module--footer-bottom--297c5";
export var footerContent = "footer-module--footer-content--37540";
export var footerLeft = "footer-module--footer-left--cb3b4";
export var footerLinks = "footer-module--footer-links--78cb6";
export var footerMiddle = "footer-module--footer-middle--df1c9";
export var footerRight = "footer-module--footer-right--6e47b";
export var footerRss = "footer-module--footer-rss--5bf16";
export var footerRssLinks = "footer-module--footer-rss-links--52e00";
export var footerRssTitle = "footer-module--footer-rss-title--c4228";
export var footerSocial = "footer-module--footer-social--bf9d0";
export var goToHead = "footer-module--go-to-head--496e9";